//import api from 'api'
import api from './axiosConfig'

export const customerEndpointApi = {

    searchCustomerEndpoints({ search, page, perPage } = {}) {
        return api
            //.get('/customer/search?search=' + search + '&page=' + page + '&perPage=' + perPage)
            .get(`/customer/searchcustomerendpoint?Search=${search}&Page=${page}&PerPage=${perPage}`)
            .then((response) => {
                return response.data
            })
    },

    createCustomerEndpoint({ name, endpoint, endpointToken, customerId } = {}) {
        return api
            .post('/customer/createcustomerendpoint', { name, endpoint, endpointToken, customerId }, {})
            .then((response) => {
                return response.data
            })
    },
	
    updateCustomerEndpoint({ id, name, endpoint, endpointToken, } = {}) {
        return api
            .put('/customer/updatecustomerendpoint', { id, name, endpoint, endpointToken }, {})
            .then((response) => {
                return response.data
            })
    }, 		
	
    getCustomerEndpoint({ id } = {}) {
        return api
            .get('/customer/getcustomerendpoint?id=' + id)
            .then((response) => {
                return response.data
            })
    },	
}